<template>
  <div class="rural-tycoon-side-banner">
    <div class="content">
      <h2 class="title">Скачивай игру</h2>
      <span class="subtitle">«Сельский магнат»</span>
      <p class="text">
        Развитие агропредприятия, викторины, технологии и многое другое ждет тебя внутри
      </p>

      <div class="button-wrapper">
        <a href="https://www.rustore.ru/catalog/app/com.rshb.ville" class="button" target="_blank">
          <img src="~/assets/images/banners/rural-tycoon/button-rustore.svg" alt="Image rustore" />
        </a>

        <!--        <a href="" class="button" target="_blank"> -->
        <!--          <img src="~/assets/images/banners/rural-tycoon/button-googleplay.svg" alt="Image googleplay" /> -->
        <!--        </a> -->
      </div>
    </div>
    <img class="logotype" src="~/assets/images/banners/rural-tycoon/logo.png" alt="Image Logo" />
  </div>
</template>

<script lang="ts" setup>
  const img = useImage()
  const bgWithSkyUrl = `url(${img('/banners/rural-tycoon/bg-with-sky.png', { format: 'webp' })})`
  const bgWithSkyMobileUrl = `url(${img('/banners/rural-tycoon/bg-with-sky-mobile.png', { format: 'webp' })})`
</script>

<style scoped lang="scss">
  .rural-tycoon-side-banner {
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 32px 16px;
    background-image:
      url('~/assets/images/banners/rural-tycoon/blur.svg'),
      v-bind(bgWithSkyUrl);
    background-size: cover, cover;
    background-position: center, center;
    background-color: $color-default-white;
    background-repeat: no-repeat, no-repeat;
    border-radius: 24px;

    @include vp-1279 {
      padding: 30px 36px;
    }

    @include vp-767 {
      padding: 28px 16px;
      background-image:
        url('~/assets/images/banners/rural-tycoon/blur-mobile.svg'),
        v-bind(bgWithSkyMobileUrl);
      background-size: cover, cover;
    }

    > .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: 585px;

      @include vp-1279 {
        max-width: 348px;
      }

      @include vp-767 {
        max-width: 185px;
      }
    }

    > .content > .title {
      font-size: 15px;
      line-height: 90%;
      font-weight: 800;
      color: $color-default-white;
      text-transform: uppercase;

      @include vp-1279 {
        font-size: 35px;
      }

      @include vp-767 {
        font-size: 16px;
      }
    }

    > .content > .subtitle {
      margin-bottom: 4px;
      font-size: 15px;
      line-height: 100%;
      font-weight: 800;
      color: #c9ff06;

      @include vp-1279 {
        font-size: 35px;
      }

      @include vp-767 {
        font-size: 16px;
      }
    }

    > .content > .text {
      margin-bottom: 10px;
      font-size: 12px;
      font-weight: 600;
      line-height: 20px;
      color: $color-default-white;

      @include vp-1279 {
        margin-bottom: 12px;
        font-size: 18px;
        line-height: 22px;
      }

      @include vp-767 {
        font-size: 11px;
        line-height: 12px;
      }
    }

    > .content > .button-wrapper {
      display: flex;
      gap: 5px;

      > .button {
        > img {
          height: 30px;

          @include vp-1279 {
            height: 40px;
          }

          @include vp-767 {
            height: 30px;
          }
        }
      }
    }

    > .logotype {
      width: 99px;
      height: 86px;

      @include vp-1279 {
        width: 231px;
        height: 201px;
      }

      @include vp-767 {
        width: 145px;
        height: 126px;
      }
    }
  }
</style>
